import {
  ChangeDetectionStrategy,
  Component,
  ViewContainerRef
} from '@angular/core';
import { TemplateStoreService } from '../template-index.store.service';
import { WorkshopJobTemplate } from 'src/app/models/workshop-job-template';
import { EditTemplateDialogComponent } from '../../edit-template-dialog/edit-template-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared';
import { WorkshopJobTemplateService } from 'src/app/shared/services/workshop-job-template.service';
import { MatDialog } from '@angular/material/dialog';
import { filter, iif, map, mergeMap, of, take } from 'rxjs';
import { UserIdToNamePipe } from '../../../../shared/pipes/user-id-to-name.pipe';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'app-template-table',
    templateUrl: './template-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgxSkeletonLoaderModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, AsyncPipe, UserIdToNamePipe]
})
export class TemplateTableComponent {
  loading$ = this.store.initialLoad$;
  data$ = this.store.templates$;
  displayedColumns = ['name', 'type', 'created_by', 'actions'];
  constructor(
    private store: TemplateStoreService,
    private templateService: WorkshopJobTemplateService,
    private vcr: ViewContainerRef,
    private dialog: MatDialog
  ) {}

  editTemplate(template: WorkshopJobTemplate) {
    this.dialog
      .open(EditTemplateDialogComponent, {
        data: template,
        width: '800px',
        viewContainerRef: this.vcr
      })
      .afterClosed()
      .pipe(
        take(1),
        filter((result) => Boolean(result))
      )
      .subscribe(({ updateList }) => {
        if (updateList) {
          this.store.getTemplates();
        }
      });
  }

  deleteTemplate({ id, name }: WorkshopJobTemplate) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Delete Template: ' + name,
          message: 'Are you sure you want to delete this template?',
          type: 'delete'
        }
      })
      .afterClosed()
      .pipe(
        take(1),
        filter((result) => Boolean(result)),
        mergeMap((result) =>
          iif(
            () => result,
            this.templateService.delete(id).pipe(map(() => true)),
            of(false)
          )
        )
      )
      .subscribe((result) => {
        if (result) {
          this.store.getTemplates();
        }
      });
  }
}
